<template>
  <div class="eventos-search-list">
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="eventos" 
            :fields="eventosFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarEvento">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
          <template v-slot:cell(fechaInicio)="data">
            {{ data.item.fechaInicio | fecha }}
          </template>
          <template v-slot:cell(fechaFin)="data">
            {{ data.item.fechaFin | fecha }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'EventosSearchList',
  props: {
    clienteId: {
      type: Number,
      default: 0
    },
    tipoEventoId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      eventos: [],
      eventosFields: [
        { 
          key: 'id',
          label: 'Nro.Evento'
        },
        { key: 'nombre' },
        { key: 'tipoEvento' },
        { key: 'fechaInicio'},
        { key: 'fechaFin'},
      ],

      labelCols: 2,
      loaded: false,
      tableBusy: false,
      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getEventos()
  },  
  methods: {
    getEventos() {
      let params = {
        clienteId: this.clienteId,
        tipoEventoId: this.tipoEventoId
      }
      this.tableBusy = true;
      this.$store.dispatch('eventos/getSearchList', params)
        .then(() => {
          this.eventos = this.$store.getters['eventos/searchList'];
          this.totalRegistros = this.eventos.length;
          this.tableBusy = false;
        })
    },
    seleccionarEvento (item) {
      this.$emit('eventoSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  .eventos-search-list .registro {
    min-height: 200px;
  }
</style>
